<script lang="ts" setup>
  import ScrollTop from 'primevue/scrolltop'
  import ShortcutStatusChange from '@/components/layout/ShortcutStatusChange.vue'
  import Toast from 'primevue/toast'
  import ConfirmDialog from 'primevue/confirmdialog'
  import AnnoucementContainer from '@/components/announcement/AnnoucementContainer.vue'
  import DynamicDialog from 'primevue/dynamicdialog'
  import DeveloperSettingsDialog from '@/components/development/DeveloperSettingsDialog.vue'
  import PersonalNotices from '@/components/layout/PersonalNotices.vue'
  import HelpDialog from '@/components/layout/HelpDialog.vue'
  import type { ComponentPublicInstance } from 'vue'
  import InputNumber from 'primevue/inputnumber'
  import { Router } from '@/helpers/router.ts'
  import { useTitropEvents } from '@/composables/useTitropEvents.ts'
  import MobileViewMenuButton from '@/components/utility/MobileViewMenuButton.vue'

  const WorktimeChecker = () => {}
  // :class="{ 'pb-24': enableDockExperimental }"

  const dialogGotoEffort = ref(false)

  const inputGotoEffort = ref<ComponentPublicInstance>()
  function gotoEffortInvoke(value?: number) {
    //inputGotoEffort.value
    if (!value) return
    dialogGotoEffort.value = false
    if (inputGotoEffort.value?.$el?.querySelector('input')) inputGotoEffort.value.$el.querySelector('input').value = ''
    Router.push({ name: 'effort_details', params: { id: value } })
  }
  function focusGotoEffortInput() {
    nextTick(() => inputGotoEffort.value?.$el?.querySelector('input').focus())
  }

  onMounted(() => {
    useTitropEvents().hotkeyGotoEffortToggle.on(() => (dialogGotoEffort.value = true))
  })
</script>

<template>
  <ScrollTop />
  <Toast position="bottom-right" />
  <ConfirmDialog />
  <WorktimeChecker />
  <ShortcutStatusChange />
  <DynamicDialog />
  <AnnoucementContainer />
  <DeveloperSettingsDialog />
  <PersonalNotices />
  <HelpDialog />
  <MobileViewMenuButton />

  <Dialog
    v-model:visible="dialogGotoEffort"
    :pt:content:class="['py-4']"
    :show-header="false"
    dismissable-mask
    @show="focusGotoEffortInput">
    <div class="flex gap-x-2 items-center">
      <span class="flex-0">Leistungobjekt-Id:</span>
      <InputNumber
        ref="inputGotoEffort"
        :format="false"
        :min="1"
        :size="'small'"
        autofocus
        class="flex-1"
        prefix="#"
        @value-change="gotoEffortInvoke" />
    </div>
  </Dialog>
</template>
